<template>
    <div>
        <router-view />
    </div>
</template>

<!-- <style scoped src="@/assets/tailwind.css"></style> -->